export const REQUEST_FETCH_ALL_PIPELINES = "REQUEST_FETCH_ALL_PIPELINES";
export const GRANT_FETCH_ALL_PIPELINES = "GRANT_FETCH_ALL_PIPELINES";
export const REVOKE_FETCH_ALL_PIPELINES = "REVOKE_FETCH_ALL_PIPELINES";
export const RESET_FETCH_ALL_PIPELINES = "RESET_FETCH_ALL_PIPELINES";

export const REQUEST_SINGLE_PIPELINE_DETAILS =
  "REQUEST_SINGLE_PIPELINE_DETAILS";
export const SET_SINGLE_PIPELINE_DETAILS = "SET_SINGLE_PIPELINE_DETAILS";
export const REVOKE_SINGLE_PIPELINE_DETAILS = "REVOKE_SINGLE_PIPELINE_DETAILS";
export const RESET_SINGLE_PIPELINE_DETAILS = "RESET_SINGLE_PIPELINE_DETAILS";
export const NULL_SINGLE_PIPELINE_DETAILS = "NULL_SINGLE_PIPELINE_DETAILS";

export const REQUEST_MOVE_PIPELINE_DATA = "REQUEST_MOVE_PIPELINE_DATA";
export const GRANT_MOVE_PIPELINE_DATA = "GRANT_MOVE_PIPELINE_DATA";
export const REVOKE_MOVE_PIPELINE_DATA = "REVOKE_MOVE_PIPELINE_DATA";
export const RESET_MOVE_PIPELINE_DATA = "RESET_MOVE_PIPELINE_DATA";

export const REQUEST_UPDATED_PIPELINE_DETAILS =
  "REQUEST_UPDATED_PIPELINE_DETAILS";
export const SET_UPDATED_PIPELINE_DETAILS = "SET_UPDATED_PIPELINE_DETAILS";
export const REVOKE_UPDATED_PIPELINE_DETAILS =
  "REVOKE_UPDATED_PIPELINE_DETAILS";
export const RESET_UPDATED_PIPELINE_DETAILS = "RESET_UPDATED_PIPELINE_DETAILS";

export const CHANGE_PIPELINES_MODALS = "CHANGE_PIPELINES_MODALS";

export const REQUEST_SEARCH_SINGLE_COMPANY = "REQUEST_SEARCH_SINGLE_COMPANY";
export const REVOKE_SEARCH_SINGLE_COMPANY = "REVOKE_SEARCH_SINGLE_COMPANY";
export const RESET_SEARCH_SINGLE_COMPANY = "RESET_SEARCH_SINGLE_COMPANY";
export const GRANT_SEARCH_SINGLE_COMPANY = "GRANT_SEARCH_SINGLE_COMPANY";

export const REQUEST_ADD_SINGLE_OPPORTUNITY = "REQUEST_ADD_SINGLE_OPPORTUNITY";
export const REVOKE_ADD_SINGLE_OPPORTUNITY = "REVOKE_ADD_SINGLE_OPPORTUNITY";
export const RESET_ADD_SINGLE_OPPORTUNITY = "RESET_ADD_SINGLE_OPPORTUNITY";
export const GRANT_ADD_SINGLE_OPPORTUNITY = "GRANT_ADD_SINGLE_OPPORTUNITY";

export const REQUEST_UPDATE_SINGLE_OPPORTUNITY =
  "REQUEST_UPDATE_SINGLE_OPPORTUNITY";
export const REVOKE_UPDATE_SINGLE_OPPORTUNITY =
  "REVOKE_UPDATE_SINGLE_OPPORTUNITY";
export const RESET_UPDATE_SINGLE_OPPORTUNITY =
  "RESET_UPDATE_SINGLE_OPPORTUNITY";
export const GRANT_UPDATE_SINGLE_OPPORTUNITY =
  "GRANT_UPDATE_SINGLE_OPPORTUNITY";

export const REQUEST_DELETE_SINGLE_OPPORTUNITY =
  "REQUEST_DELETE_SINGLE_OPPORTUNITY";
export const REVOKE_DELETE_SINGLE_OPPORTUNITY =
  "REVOKE_DELETE_SINGLE_OPPORTUNITY";
export const RESET_DELETE_SINGLE_OPPORTUNITY =
  "RESET_DELETE_SINGLE_OPPORTUNITY";
export const GRANT_DELETE_SINGLE_OPPORTUNITY =
  "GRANT_DELETE_SINGLE_OPPORTUNITY";

export const SET_ACTIVE_PIPELINE_UNIT = "SET_ACTIVE_PIPELINE_UNIT";
export const RESET_ACTIVE_PIPELINE_UNIT = "RESET_ACTIVE_PIPELINE_UNIT";

export const REQUEST_CREATE_NEW_PIPELINE = "REQUEST_CREATE_NEW_PIPELINE";
export const SET_CREATE_NEW_PIPELINE = "SET_CREATE_NEW_PIPELINE";
export const REVOKE_CREATE_NEW_PIPELINE = "REVOKE_CREATE_NEW_PIPELINE";
export const RESET_CREATE_NEW_PIPELINE = "RESET_CREATE_NEW_PIPELINE";

export const SET_EDIT_SINGLE_PIPELINE = "SET_EDIT_SINGLE_PIPELINE";
export const RESET_EDIT_SINGLE_PIPELINE = "RESET_EDIT_SINGLE_PIPELINE";

export const REQUEST_DELETE_SINGLE_PIPELINE = "REQUEST_DELETE_SINGLE_PIPELINE";
export const REVOKE_DELETE_SINGLE_PIPELINE = "REVOKE_DELETE_SINGLE_PIPELINE";
export const RESET_DELETE_SINGLE_PIPELINE = "RESET_DELETE_SINGLE_PIPELINE";
export const GRANT_DELETE_SINGLE_PIPELINE = "GRANT_DELETE_SINGLE_PIPELINE";

export const REQUEST_UPDATE_SINGLE_PIPELINE = "REQUEST_UPDATE_SINGLE_PIPELINE";
export const REVOKE_UPDATE_SINGLE_PIPELINE = "REVOKE_UPDATE_SINGLE_PIPELINE";
export const RESET_UPDATE_SINGLE_PIPELINE = "RESET_UPDATE_SINGLE_PIPELINE";
export const GRANT_UPDATE_SINGLE_PIPELINE = "GRANT_UPDATE_SINGLE_PIPELINE";
